<template>
  <div class="configuration">
    <!-- <TabsHead active-tab="configuration"> </TabsHead> -->
    <Table :loading="loading" :columns="recordsCol" :data="ConnectionssData"></Table>
  </div>
</template>
<script>
import nodeID from '@/mixins/nodeID'
import { getConnections } from '@/api/configuration'
import ConfKeysTable from '@/components/ConfKeysTable'
import TabsHead from '@/components/TabsHead'
import currentLang from '@/mixins/currentLang'
import installPlugin from '@/mixins/installPlugin'
import { RESOURCE_TYPE } from '@/utils/constants'

export default {
  name: 'Configuration',

  mixins: [nodeID, currentLang, installPlugin],

  components: {
    TabsHead,
  },

  data() {
    return {
      RESOURCE_TYPE,
      loading: false,
      ConnectionssData: [],
      recordsCol: [
        {
          type: 'expand',
          width: 50,
          render: (h, params) => {
            return <ConfKeysTable row={params.row} configType="connection"></ConfKeysTable>
          },
        },
        {
          title: this.$t('common.name'),
          width: 120,
          key: 'name',
        },
        {
          title: this.$t('common.description'),
          minWidth: 220,
          render: (h, params) => {
            const { description } = params.row.about
            return <p>{this.i18nLabel(description)}</p>
          },
        },
        {
          title: this.$t('common.trial'),
          width: 80,
          render: (h, params) => {
            const isTrial = params.row.about.trial ? this.$t('common.yes') : this.$t('common.no')
            return <p>{isTrial}</p>
          },
        },
        {
          title: this.$t('plugins.installed'),
          width: 100,
          render: (h, params) => {
            const isInstalled = params.row.about.installed ? this.$t('common.yes') : this.$t('common.no')
            return <p>{isInstalled}</p>
          },
        },
        {
          title: this.$t('common.operations'),
          width: 200,
          render: (h, params) => {
            const { helpUrl, installed } = params.row.about
            const installOper = (
              <a
                href="javascript:;"
                style="margin-right:10px;"
                onClick={() => {
                  this.routeToInstallPage(params.row.name)
                }}
              >
                {this.$t('common.install')}
              </a>
            )
            return (
              <div>
                {installed ? null : installOper}
                <a href={this.i18nLabel(helpUrl)} target="_blank" rel="noopener">
                  {this.$t('common.documentation')}
                </a>
              </div>
            )
          },
        },
      ],
    }
  },

  created() {
    this.loadConnections()
  },

  methods: {
    loadConnections() {
      this.loading = true
      getConnections(this.nodeID).then((res) => {
        this.ConnectionssData = res.data
        this.loading = false
      })
    },
    routeToInstallPage(name) {
      this.goToInstallPluginPage(RESOURCE_TYPE.sources, name)
    },
  },
}
</script>

<style lang="scss"></style>
